import React from 'react'
import { getColorByIndex, getContrastColor } from '../../utils/colors.helper'
import { isNil } from 'lodash'
import { PATTERN_TYPES } from '../../constants/pattern-types'

const PatternIcon = ({
    id,
    content = id,
    type,
    colorId = id,
    color,
    sizeInPx = 22,
    style: customStyle,
    showId = true,
    suffix,
}) => {
    if (isNil(id)) return null

    let iconStyle = {
        // Square
        color: getContrastColor(color || getColorByIndex(colorId).value),
        backgroundColor: color || getColorByIndex(colorId).value,
        minWidth: sizeInPx,
        height: sizeInPx,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 4,
        padding: '0 4px',
        ...customStyle,
    }
    let title

    if (type === PATTERN_TYPES.SEMANTIC.value) {
        // Circle
        title = PATTERN_TYPES.SEMANTIC.name
        iconStyle = { ...iconStyle, borderRadius: '50%' }
    } else if (type === PATTERN_TYPES.QUERY.value) {
        // Hexagon
        title = PATTERN_TYPES.QUERY.name
        iconStyle = {
            ...iconStyle,
            clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)',
            width: sizeInPx,
            height: sizeInPx, // Adjust the height to maintain aspect ratio
        }
    } else if (type === PATTERN_TYPES.LBE.value) {
        // Square
        title = PATTERN_TYPES.LBE.name
    }

    return (
        <span style={iconStyle} title={title}>
            {showId ? `${content ?? ''}${suffix ?? ''}` : '\u00A0'} {/* Unicode for non-breaking space */}
        </span>
    )
}

export default PatternIcon
